module.exports = __webpack_public_path__ + "img/31-None of these.2392642c.png";